import { ROUTES } from '@/lib/routes';

export type Audience = {
  id: 'docentes' | 'directivos' | 'especialistas' | 'desarrolladores';
  label: string;
  task: string;
  cta: string;
  href: string;
};

/**
 * Audience priority order is fixed by docs/about/vision.md "Audiencias prioritarias en orden".
 * Do not reorder.
 */
export const AUDIENCES: readonly Audience[] = [
  {
    id: 'docentes',
    label: 'Docente',
    task: 'Tu planificación, anclada al NAP y a tu jurisdicción.',
    cta: 'Para docentes',
    href: ROUTES.audiencias.docentes,
  },
  {
    id: 'directivos',
    label: 'Directivo',
    task: 'Auditá la coherencia curricular de tu institución.',
    cta: 'Para directivos',
    href: ROUTES.audiencias.directivos,
  },
  {
    id: 'especialistas',
    label: 'Especialista',
    task: 'Compará jurisdicciones lado a lado.',
    cta: 'Para especialistas',
    href: ROUTES.audiencias.especialistas,
  },
  {
    id: 'desarrolladores',
    label: 'Desarrollador IA',
    task: 'Conectá tu agente vía Model Context Protocol.',
    cta: 'Para desarrolladores',
    href: ROUTES.audiencias.desarrolladores,
  },
];
